<template>
    <div>
        <div v-if="trialCheckIns.length > 0" class="m-t-xxs relative border border-solid border-green-500 rounded-xxs p-sm">
          <p class="subheadline absolute text-12 font-semi top-0 left-0 bg-green-500 text-green-50 uppercase tracking-wide p-x-m p-y-xs rounded-tl-xxs">
            Trial Wrestlers Present
          </p>
          <div class="m-t-lg flex flex-wrap gap-sm">
            <div v-for="checkIn in trialCheckIns">
              <div v-if="avatar(checkIn)" class="flex justify-center align-items-center">
                <component :is="forAppEmbed ? 'div' : 'a'" 
                          :href="!forAppEmbed ? wrestlerHref(checkIn) : undefined" 
                          target="_blank">
                  <div class="image">
                    <img :src="avatar(checkIn)" class="profile-pic" alt="profile picture"/>
                  </div>
                </component>
              </div>
              <div v-else class="flex justify-center align-items-center">
                <svg class="profile-pic color-gray-400" fill="currentcolor" id="Line" style="enable-background:new 0 0 128 128; display: block;" version="1.1"
                     viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M99.298,106.402c-0.014-6.198-1.627-13.411-12.443-17.109c-0.218-7.678-0.69-15.571-1.408-23.485   c1.097-1.425,1.97-2.743,2.641-3.866C95.742,61.35,101,54.56,101,45c0-5.913-0.75-13.402-6.277-16.033   c-1.114-6.278-5.69-11.965-12.66-15.672c-1.435-1.276-3.057-2.416-4.892-3.356C74.217,4.339,69.317,1,64,1   c-5.319,0-10.216,3.338-13.17,8.939c-1.834,0.94-3.456,2.079-4.89,3.354c-6.971,3.707-11.549,9.395-12.663,15.674   C27.75,31.598,27,39.087,27,45c0,9.56,5.258,16.35,12.912,16.942c0.671,1.123,1.543,2.441,2.641,3.866   c-0.718,7.924-1.19,15.816-1.407,23.485c-10.807,3.694-12.427,10.901-12.444,17.11c-3.626,9.638-3.7,19.193-3.701,19.597   c-0.001,0.266,0.104,0.521,0.292,0.709c0.188,0.188,0.443,0.294,0.708,0.294h76c0.266,0,0.521-0.106,0.708-0.294   c0.188-0.188,0.292-0.444,0.292-0.709C102.999,125.596,102.924,116.04,99.298,106.402z M84.833,88.675   c-0.974-0.267-2.014-0.507-3.121-0.721l-0.071-0.203c-0.109-0.313-0.367-0.553-0.688-0.638c-1.842-0.491-3.819-0.82-5.876-0.98   c-0.072-0.005-0.138,0.014-0.206,0.024l-0.614-8.592c3.394-1.955,4.919-4.549,5.452-5.679c1.487-1.291,2.79-2.599,3.917-3.872   C84.22,74.977,84.627,81.906,84.833,88.675z M89.022,125.004H38.977c-0.637-1.638-0.977-3.315-0.977-5   c0-2.019,0.42-3.966,1.243-5.775l0.107-0.226c0.016-0.033,0.029-0.066,0.041-0.1l8.681-24.988c1.302-0.32,2.675-0.556,4.096-0.705   l1.842,10.936c0.011,0.079,1.224,7.858,9.989,7.858c8.766,0,9.979-7.78,9.986-7.834l1.846-10.96   c1.421,0.149,2.793,0.385,4.096,0.705l8.682,24.988c0.012,0.034,0.025,0.067,0.041,0.1l0.101,0.212   c0.829,1.822,1.249,3.77,1.249,5.789C90,121.688,89.659,123.365,89.022,125.004z M49.483,70.125   c-0.094-0.052-0.194-0.086-0.296-0.105c-3.448-3.082-5.797-6.277-7.268-8.653c0.058-0.146,0.091-0.3,0.076-0.46l-2.034-21.696   c2.528-2.91,5.296-5.316,8.032-7.286C52.746,31.41,58.311,31,64,31c5.67,0,11.219,0.407,15.964,0.921   c2.761,1.976,5.549,4.385,8.075,7.29l-2.034,21.696c-0.015,0.16,0.018,0.314,0.076,0.46c-1.472,2.376-3.821,5.571-7.27,8.654   c-0.099,0.018-0.195,0.051-0.286,0.1C78.489,70.139,74.851,72,64,72S49.511,70.139,49.483,70.125z M39.158,30.634   c0.812-6.556,4.608-14.984,12.853-19.062C55.461,9.865,59.495,9,64,9c4.505,0,8.539,0.865,11.99,2.572   c8.249,4.081,12.042,12.505,12.852,19.066l-0.041,0.436c-2.19-0.343-4.942-0.731-8.058-1.078   c-8.244-5.814-16.053-7.853-16.498-7.965C64.165,22.01,64.082,22,64,22c-0.088,0-8.202,2.024-16.707,7.992   c-3.131,0.348-5.895,0.738-8.093,1.082L39.158,30.634z M88.291,36.514c-1.429-1.515-2.913-2.888-4.413-4.126   c1.774,0.231,3.369,0.465,4.736,0.68L88.291,36.514z M76.368,29.563C72.505,29.23,68.287,29,64,29   c-4.312,0-8.554,0.233-12.435,0.568c6.043-3.65,11.276-5.215,12.43-5.533C65.16,24.366,70.373,25.961,76.368,29.563z M44.14,32.385   c-1.509,1.24-3,2.614-4.431,4.129l-0.323-3.447C40.757,32.852,42.358,32.617,44.14,32.385z M64,74   c6.423,0,10.451-0.635,12.784-1.211C75.077,74.954,71.366,78,64,78c-7.437,0-11.128-3.051-12.812-5.219   C53.516,73.359,57.55,74,64,74z M64,80c3.434,0,6.159-0.604,8.319-1.489l0.683,9.565c0.029,0.411,0.307,0.741,0.678,0.867   l-1.67,9.917c-0.038,0.251-1.007,6.145-8.011,6.145c-7.003,0-7.972-5.894-8.013-6.166l-1.667-9.895   c0.371-0.126,0.648-0.456,0.678-0.867l0.683-9.565C57.841,79.396,60.566,80,64,80z M99,45c0,7.845-3.894,13.588-9.716,14.774   c0.409-0.818,0.616-1.329,0.646-1.406c0.203-0.514-0.049-1.093-0.562-1.296c-0.357-0.142-0.739-0.052-1.012,0.181l2.237-23.86   c1.996,0.34,3.164,0.579,3.204,0.587c0.537,0.11,1.07-0.235,1.182-0.776s-0.235-1.07-0.776-1.182   c-0.042-0.009-1.296-0.266-3.423-0.625l0.128-1.363C96.568,30.457,99,35.004,99,45z M92.524,28.242   c-0.649-0.133-1.353-0.206-2.104-0.228c-0.62-2.882-1.748-5.956-3.486-8.837C89.759,21.823,91.69,24.931,92.524,28.242z M64,3   c3.797,0,7.375,2.037,9.968,5.567C70.951,7.526,67.611,7,64,7c-3.612,0-6.952,0.526-9.969,1.567C56.624,5.037,60.201,3,64,3z    M41.07,19.172c-1.74,2.883-2.869,5.958-3.489,8.841c-0.751,0.022-1.455,0.096-2.105,0.229C36.31,24.929,38.242,21.82,41.07,19.172   z M29,45c0-9.996,2.432-14.543,8.092-14.967l0.128,1.363c-2.127,0.36-3.381,0.616-3.423,0.625   c-0.541,0.112-0.888,0.642-0.776,1.182C33.119,33.675,33.535,34,33.999,34c0.067,0,0.136-0.007,0.204-0.021   c0.04-0.008,1.208-0.248,3.204-0.587l2.237,23.86c-0.272-0.233-0.654-0.322-1.012-0.181c-0.513,0.203-0.765,0.783-0.562,1.296   c0.03,0.077,0.237,0.589,0.646,1.406C32.894,58.588,29,52.845,29,45z M44.374,68.013c1.127,1.273,2.43,2.581,3.917,3.872   c0.533,1.13,2.057,3.723,5.451,5.679l-0.613,8.592c-0.069-0.009-0.135-0.029-0.207-0.023c-2.057,0.16-4.035,0.49-5.876,0.98   c-0.321,0.085-0.578,0.325-0.688,0.638l-0.07,0.203c-1.107,0.214-2.147,0.454-3.121,0.721   C43.372,81.913,43.779,74.984,44.374,68.013z M30.636,106.942c0.043-0.115,0.066-0.256,0.066-0.379   c-0.01-4.312-0.025-13.117,14.823-16.411l-8.006,23.044l-0.09,0.191c-0.948,2.084-1.429,4.31-1.429,6.617   c0,1.685,0.287,3.36,0.839,5h-9.808C27.153,122.294,27.749,114.525,30.636,106.942z M91.16,125.004c0.552-1.641,0.84-3.316,0.84-5   c0-2.307-0.48-4.533-1.435-6.63l-8.087-23.221c14.846,3.295,14.831,12.1,14.821,16.434c0,0.122,0.022,0.242,0.065,0.356   c2.887,7.583,3.482,15.352,3.605,18.062H91.16z"/><path
                    d="M57.165,38.014l-6-1c-0.546-0.09-1.06,0.278-1.151,0.822c-0.091,0.545,0.277,1.06,0.822,1.151l6,1   C56.891,39.996,56.947,40,57.001,40c0.48,0,0.904-0.347,0.985-0.835C58.077,38.62,57.709,38.104,57.165,38.014z"/><path
                    d="M70.999,40c0.054,0,0.11-0.004,0.166-0.014l6-1c0.544-0.091,0.913-0.606,0.822-1.151c-0.091-0.544-0.602-0.912-1.151-0.822   l-6,1c-0.544,0.091-0.913,0.606-0.822,1.151C70.095,39.653,70.519,40,70.999,40z"/><path
                    d="M54.263,40.912h-0.527c-1.509,0-2.736,1.228-2.736,2.737v2.526c0,1.509,1.228,2.737,2.736,2.737h0.527   c1.509,0,2.737-1.228,2.737-2.737v-2.526C57,42.139,55.772,40.912,54.263,40.912z M55,46.175c0,0.406-0.331,0.737-0.737,0.737   h-0.527c-0.406,0-0.736-0.331-0.736-0.737v-2.526c0-0.406,0.33-0.737,0.736-0.737h0.527c0.399,0,0.737,0.337,0.737,0.737V46.175z"/><path
                    d="M74.263,40.912h-0.527c-1.509,0-2.736,1.228-2.736,2.737v2.526c0,1.509,1.228,2.737,2.736,2.737h0.527   c1.509,0,2.737-1.228,2.737-2.737v-2.526C77,42.139,75.772,40.912,74.263,40.912z M75,46.175c0,0.406-0.331,0.737-0.737,0.737   h-0.527c-0.406,0-0.736-0.331-0.736-0.737v-2.526c0-0.406,0.33-0.737,0.736-0.737h0.527c0.399,0,0.737,0.337,0.737,0.737V46.175z"/><path
                    d="M68.797,60.158c-0.334-0.44-0.961-0.525-1.401-0.192C66.491,60.652,65.348,61,64,61c-1.348,0-2.49-0.348-3.396-1.034   c-0.441-0.335-1.068-0.248-1.401,0.193c-0.333,0.44-0.247,1.067,0.193,1.401C60.657,62.516,62.206,63,64,63   c1.795,0,3.344-0.485,4.605-1.441C69.044,61.225,69.13,60.598,68.797,60.158z"/></g>
                  </svg>
              </div>
              <p style="max-width: 128px;" class="text-center">
                <component :is="forAppEmbed ? 'span' : 'a'"
                          :href="!forAppEmbed ? wrestlerHref(checkIn) : undefined"
                          target="_blank">
                  {{ checkIn.profile.display_name }}
                  <i v-if="!forAppEmbed" class="fa fa-external-link"></i>
                </component>
              </p>
            </div>
          </div>
        </div>
        <div v-if="dropInCheckIns.length > 0" class="m-t-sm relative border border-solid border-gray-500 rounded-xxs p-sm">
        <p class="absolute subheadline text-12 font-semi top-0 left-0 bg-gray-500 text-gray-50 uppercase tracking-wide p-x-m p-y-xs rounded-tl-xxs">
          Drop In Wrestlers Present
        </p>
        <div class="m-t-lg flex flex-wrap gap-sm">
          <div v-for="checkIn in dropInCheckIns">
            <div v-if="avatar(checkIn)">
              <component :is="forAppEmbed ? 'div' : 'a'"
                        :href="!forAppEmbed ? wrestlerHref(checkIn) : undefined"
                        target="_blank">
                <div class="image">
                  <img :src="avatar(checkIn)" class="profile-pic" alt="profile picture"/>
                </div>
              </component>
            </div>
            <p>
              <component :is="forAppEmbed ? 'span' : 'a'"
                        :href="!forAppEmbed ? wrestlerHref(checkIn) : undefined"
                        target="_blank">
                {{ checkIn.profile.display_name }}
                <i v-if="!forAppEmbed" class="fa fa-external-link"></i>
              </component>
            </p>
          </div>
        </div>
      </div>
        <div class="flex align-items-center justify-space-between m-t-m" v-show="!showEmptyState || skipEmptyState">
            <div class="">
                <p class="upper-label m-b-none m-t-none">Checked in</p>
                <p v-if="this.loading || this.presentCount === 0" class="font-heavy text-16 m-t-n">--</p>
                <p v-else class="font-heavy text-16 m-t-n">{{ this.presentCount }}</p>
            </div>
            <div v-if="!forAppEmbed">
                <button class="btn btn-default" @click.prevent="downloadCSV">Download Attendance Report</button>
            </div>
        </div>
        <div class="form-group m-t-sm" v-show="!showEmptyState || skipEmptyState">
            <div style="position: relative;">
                <input v-model="debouncedSearchTerm" ref="wsearch" type="text" id="wrestler_search" placeholder="Find by name or weight.."
                       class="form-control"
                       maxlength="25"/>
                <i @click="debouncedSearchTerm = ''" v-if="debouncedSearchTerm && debouncedSearchTerm.length > 0"
                   class="cursor-pointer fa fa-times color-gray-400"
                   style="position: absolute; top:0; bottom:0; right: 0; transform: translate(-66%, 29%)"></i>
            </div>
        </div>
        <div>
            <p v-if="error" class="text-danger">
                {{ errorMessage }}
            </p>
        </div>
        <spinner v-if="loading"></spinner>
        <div class="relative" v-if="!loading">
            <check-in-form v-for="wrestler in searchedProfiles"
                           :for-app-embed="forAppEmbed"
                           :key="wrestler.id"
                           :wrestler-profile="wrestler"
                           :check-in="checkInFor(wrestler)"
                           :event-id="event.id"
                           :editable="canEdit"
                           :questions="checkInQuestions"
                           :endpoint="endpoint"
                           :access-key="accessKey"
                           :cloudfront-base-url="cloudfrontBaseUrl"
            ></check-in-form>
        </div>
        <div v-if="showEmptyState && !skipEmptyState" class="m-t-sm relative border border-solid border-green-600 rounded-xxs">
          <div class="flex align-items-center justify-center gap-sm bg-green-600 text-green-50 uppercase tracking-wide p-x-m p-y-xs -m-sm rounded-t-xxs">
            <span class="text-heavy">WIQ RECOMMENDATION</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-green-50">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
            </svg>
          </div>
          <div class="p-x-lg p-y-md grid grid-cols-2 gap-y-sm gap-x-lg sm-grid-cols-1 md-grid-cols-1 m-t-sm">
            <div>
              <h1 class="m-t-none font-heavy">
              Link Rosters To This Event
              </h1>
              <p>
                Connect the appropriate rosters to unlock powerful event management features:
              </p>
              <ul class="p-l-sm">
                <li>Automatically filter attendance tracking to only show relevant wrestlers.</li>
                <li>Send targeted notifications about schedule changes to only those rosters.</li>
                <li>Easily invite selected rosters to this event with event invites.</li>
              </ul>
            </div>
            <div class="flex flex-col gap-xl justify-center w-full p-x-md">
              <div class="flex flex-col gap-sm justify-center align-items-center">
                <a @click.prevent="handleEditClick" 
                   :href="editEventPath" 
                   class="btn btn-primary btn-block w-full justify-center flex align-items-center gap-x-xs">
                  <i class='fa fa-pencil'></i> Edit Event - Link Rosters
                </a>
                <a href="javascript:void(0)" onclick="Beacon('article', '6328c8ff62b5f93d180188ad', { type: 'modal' })" class="btn btn-default btn-block w-full justify-center flex align-items-center gap-x-xs"><i class='fa fa-play'></i>
                  Watch Tutorial Video</a>
              </div>
              <div class="border-t border-solid border-gray-50 p-t-md text-center">
                <button class="btn btn-default btn-block w-full justify-center flex align-items-center gap-x-xs" @click="loadAllWrestlersManually"><i class="fa fa-fast-forward"></i> Skip - Load All Wrestlers For Attendance</button>
                <p class="text-12 text-gray-500">Are you sure? Linking a roster takes < 20 seconds.</p>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import { downloadMix } from './mixins/download_mix';
import { appEmbedMix } from './mixins/app_embed_mix';
import Spinner from './spinner.vue';
import CheckInForm from './check_in_form.vue';

export default {
  name: 'attendance-list',
  mixins: [downloadMix, appEmbedMix],
  components: {
    CheckInForm,
    Spinner
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    accessKey: {
      type: String,
      required: true
    },
    cloudfrontBaseUrl: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      deafult: true
    },
    // The roster filter is asynchronous, so we need to skip the empty state if we're waiting for that
    skipEmptyState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      wrestlers: [],
      checkIns: [],
      error: false,
      errorMessage: '',
      wrestlersUrl: null,
      checkInQuestions: [],
      search: '', // This is what we are searching for
      debouncedSearchTerm: '', // This is the model we debounce that the user types in.
      sort: 'last_name',
      rosters: [],
      hasInitializedWrestlers: false
    };
  },
  created() {
    const vm = this;
    vm.wrestlers = [];
    vm.wrestlersUrl = null;

    vm.$notificationManager.$on('wrestler-checked-in', vm.updateCheckIn);
    vm.$notificationManager.$on('roster-filter-applied', vm.changeRoster);
    vm.$notificationManager.$on('sort-filter-applied', vm.changeSort);
    this.getSearchResults = _.debounce(this.getSearchResults, 500);
  },
  destroyed() {
    const vm = this;

    vm.$notificationManager.$off('wrestler-checked-in', vm.updateCheckIn);
    vm.$notificationManager.$off('roster-filter-applied', vm.changeRoster);
  },
  computed: {
    trialCheckIns() {
      return _.filter(this.checkIns, (c) => {
        return c.class_pass?.paid_session?.session_type === 'trial';
      });
    },
    dropInCheckIns() {
      return _.filter(this.checkIns, (c) => {
        return c.class_pass?.paid_session?.session_type === 'dropin';
      });
    },
    presentCount() {
      return _.filter(this.checkIns, (c) => {
        return c.status === 'present';
      }).length;
    },
    searchedProfiles() {
      if (!this.search || this.search === '') {
        return this.wrestlers;
      }

      if (isNaN(this.search)) {
        return this.wrestlers.filter(wp => wp.full_name.toLowerCase()
          .includes(this.search.toLowerCase()));
      } else {
        return this.wrestlers.filter(wp => wp.weight_class.includes(this.search));
      }
    },
    showEmptyState() {
      return !this.hasInitializedWrestlers && 
             this.rosters.length === 0 && 
             !this.loading;
    },
    editEventPath() {
      return this.forAppEmbed 
        ? `${window.location.origin}/app_embeds/events/${this.event.id}/edit`
        : `/events/${this.event.id}/edit`;
    }
  },
  watch: {
    // whenever search changes, this function will run
    debouncedSearchTerm(newSearch) {
      this.getSearchResults();
    },
  },
  methods: {
    getSearchResults() {
      this.search = this.debouncedSearchTerm;
    },
    avatar(checkIn) {
      return checkIn?.profile?.avatar;
    },
    wrestlerHref(checkIn) {
      return `/wrestlers/${checkIn.profile?.id}`;
    },
    changeRoster(rosters, strategy) {
      const vm = this;
      vm.rosters = rosters;
      vm.wrestlers = [];
      
      if (rosters.length > 0) {
        vm.hasInitializedWrestlers = true;
      }
      
      if (rosters.length === 0 && !vm.hasInitializedWrestlers) {
        vm.wrestlersUrl = null;
        vm.loading = false;
        return;
      }
      
      vm.checkForFilterChange();
    },
    changeSort(sort) {
      const vm = this;
      vm.sort = sort;
      
      // Don't trigger a load if we haven't initialized wrestlers yet
      if (!vm.hasInitializedWrestlers) {
        return;
      }
      
      vm.checkForFilterChange();
    },
    checkForFilterChange() {
      const rosterIds = _.map(this.rosters, 'id');
      // Only include guests if we have roster filters
      const includeGuests = rosterIds.length > 0;
      let newUrl = this.$apiService.filteredWrestlers(includeGuests, rosterIds, this.sort, 100, 'union');
      
      if (newUrl !== this.wrestlersUrl) {
        this.wrestlersUrl = newUrl;
        this.loadAllWrestlers();
      }
    },
    loadAllWrestlers: _.throttle(function () {
      const vm = this;
      if (vm.loading || !vm.wrestlersUrl) {
        return;
      }

      // Store the current URL to compare after the request
      const requestUrl = vm.wrestlersUrl;
      
      vm.loading = true;
      vm.error = false;

      vm.$apiService.loadAllPages(requestUrl, 'wrestlers')
        .then((objects) => {
          // Only update if the URL hasn't changed during the request
          if (requestUrl === vm.wrestlersUrl) {
            vm.wrestlers = objects;
            vm.loadAllCheckIns();
          } else {
            // If URL changed, we're already loading new data
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = `Error retrieving wrestlers ${error.toString()}`;
          vm.error = true;
        });
    }, 500),
    loadAllCheckIns() {
      const vm = this;
      const url = vm.$apiService.checkInsUrl(vm.event.id);

      vm.$apiService.loadAllPages(url, 'check_ins')
        .then((objects) => {
          vm.checkIns = objects;
          vm.loadAllRegistrationQuestions();
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = `Error retrieving attendance check-ins ${error.toString()}`;
          vm.error = true;
        });
    },
    loadAllRegistrationQuestions() {
      const vm = this;
      const url = vm.$apiService.registrationQuestions('CheckIn');

      vm.$apiService.loadAllPages(url, 'registration_questions')
        .then((objects) => {
          vm.checkInQuestions = objects;
          vm.loading = false;
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = `Error retrieving custom check in questions ${error.toString()}`;
          vm.error = true;
        });
    },
    checkInFor(wrestler) {
      const vm = this;
      const wrestlerId = wrestler.id;

      return _.find(vm.checkIns, (check) => check.wrestler_profile_id === wrestlerId);
    },
    buildLocalCheckIn(id, status, wrestler) {
      return {
        id,
        status,
        wrestler_profile_id: wrestler.id,
        profile: {
          id: wrestler.id,
          display_name: `${wrestler.first_name} ${wrestler.last_name}`,
          avatar: wrestler.avatar,
        },
        event_id: this.event.id,
        questions: this.checkInQuestions,
        answers: [],
        notes: '',
        class_pass: {},
      };
    },
    // This is a pretty terrible perversion of Vue I committed a long time ago.
    // This uses the event bus to keep this parent data in sync with the
    // data being manipulated in the check in form. It works this way
    // because I did not understand javascript objects are passed by reference.
    // If I were to build this from the ground, I would build the local check ins first
    // however, this does keep the data source of truth clean (here), the child components
    // just manipulate the data and essentially commit a 'mutation' against the data in Vuex terms

    // One more udpate: I do not understand how this works. This emit event seems to keep the list in sync
    // But without updating the child component.. oohhh I bet it's because we did not use $set
    // So what's the real answer I would want here.
    updateCheckIn(checkInId, status, wrestlerProfile, notes, classPass) {
      const vm = this;
      let checkIn = vm.checkInFor(wrestlerProfile);

      if (!checkIn) {
        checkIn = vm.buildLocalCheckIn(checkInId, status, wrestlerProfile);
      }

      // set the new status regardless of new or updated
      checkIn.status = status;
      checkIn.notes = notes;
      checkIn.class_pass = classPass;

      // Insert the check in to our source of truth after it's been manipulated here.
      const index = _.findIndex(vm.checkIns, { id: checkInId });
      if (index !== -1) {
        vm.checkIns.splice(index, 1, checkIn);
      } else {
        vm.checkIns.push(checkIn);
      }
    },
    notesForCheckIn(checkIn) {
      // if the check in has a free trial pass, add that info to the notes
      if (checkIn?.class_pass?.paid_session?.session_type === 'trial') {
        checkIn.notes = `${checkIn.notes} Trial Pass Used: ${checkIn.class_pass.paid_session.name}`;
      }

      // Do the same check for dropin session_type
      if (checkIn?.class_pass?.paid_session?.session_type === 'dropin') {
        checkIn.notes = `${checkIn.notes} Drop In Pass Used: ${checkIn.class_pass.paid_session.name}`;
      }

      return checkIn?.notes;
    },
    downloadCSV() {
      const vm = this;

      const rows = [];
      rows.push([
        'Last name',
        'First name',
        'Status',
        'Notes'
      ]);

      let wrestlerMap = {};

      vm.wrestlers.forEach((wrestler) => {
        let checkIn = vm.checkInFor(wrestler);

        rows.push([
          wrestler.last_name,
          wrestler.first_name,
          _.capitalize(checkIn?.status),
          this.notesForCheckIn(checkIn)
        ]);
        wrestlerMap[wrestler.id] = checkIn;
      });

      // We do a second loop through check ins, to handle drop ins and trial pass wrestlers, which get filtered out if the page is reloaded.
      vm.checkIns.forEach((checkIn) => {
        if (!wrestlerMap[checkIn.wrestler_profile_id]) {
          // grab the first adn last name by splitting up display name on space
          let names = checkIn.profile.display_name.split(' ');
          let lastName = names.pop();
          let firstName = names.pop();
          rows.push([
            lastName,
            firstName,
            _.capitalize(checkIn.status),
            this.notesForCheckIn(checkIn)
          ]);
        }
      });

      const fileName = `Attendance Report - ${vm.event.name} ${moment(vm.event.start_at)
        .format('M/D/YYYY')}.csv`;
      this.downloadCSVFile(fileName, rows);
    },
    loadAllWrestlersManually() {
      this.hasInitializedWrestlers = true;
      this.wrestlersUrl = this.$apiService.filteredWrestlers(false, [], this.sort, 100, 'union');
      this.loadAllWrestlers();
    },
    handleEditClick(e) {
      if (this.forAppEmbed) {
        this.askAppToPush(this.editEventPath, 'Edit Event');
      } else {
        // Regular web navigation
        window.location.href = this.editEventPath;
      }
    }
  },
};
</script>
